import { FormControl, FormLabel, TextField, Typography } from '@mui/material';
import { FieldError } from 'react-hook-form';
import { ControllerRenderProps } from 'react-hook-form/dist/types/controller';

interface TextareaFieldProps {
  label: string;
  disabled: boolean;
  value: string;
  onChange: ControllerRenderProps['onChange'];
  error?: FieldError;
  name: string;
  readOnly: boolean;
}

export const TextareaField = ({ label, disabled, value, onChange, error, name, readOnly }: TextareaFieldProps) => {
  return (
    <>
      <FormControl fullWidth size="small" data-cy-field-type="textarea">
        <FormLabel id={`${name}-label`}>{label}</FormLabel>
        <TextField
          size="small"
          multiline
          rows={5}
          aria-labelledby={`${name}-label`}
          value={value}
          error={!!error}
          disabled={disabled}
          name={name}
          onChange={(event) => onChange(event.target.value)}
          inputProps={{ readOnly }}
        />
      </FormControl>
      {error ? <Typography color="error">{error!.message as string}</Typography> : <br />}
    </>
  );
};

// for React.lazy
export default TextareaField;
